export const Field = ({ label, required, testid, textarea, ...props }) => {
  const cls = "field-dark w-full rounded-xl px-4 py-3 text-sm placeholder:text-[#6b6157] focus:outline-none focus:border-amber-500 transition-colors";
  return (
    <label className="block">
      <span className="text-xs text-[#A89F91] font-medium">{label}{required && <span className="text-red-400"> *</span>}</span>
      <div className="mt-1.5">
        {textarea ? <textarea rows={2} className={cls} data-testid={testid} {...props} /> : <input className={cls} data-testid={testid} {...props} />}
      </div>
    </label>
  );
};

export const Card = ({ title, icon: Icon, children }) => (
  <section className="rounded-2xl bg-[#1C1515] border border-[#2E2323] p-5 space-y-4 rise">
    <h2 className="text-base font-bold text-amber-50 flex items-center gap-2">{Icon && <Icon className="w-5 h-5 text-amber-400" />}{title}</h2>
    {children}
  </section>
);

export const Toggle2 = ({ options, value, onChange, prefix }) => (
  <div className="grid grid-cols-2 gap-2">
    {options.map(({ value: v, label, icon: Icon }) => (
      <button key={v} type="button" onClick={() => onChange(v)} data-testid={`${prefix}-${v}`}
        className={`py-3.5 rounded-xl text-sm font-semibold border flex items-center justify-center gap-2 transition-colors ${value === v ? "bg-[#DC2626] border-[#DC2626] text-white" : "bg-[#120E0E] border-[#2E2323] text-[#A89F91]"}`}>
        {Icon && <Icon className="w-4 h-4" />}{label}
      </button>
    ))}
  </div>
);
